angular
	.module 'App.Directive'
	.directive 'wmIntegrationFailedTransfers', ->
		scope:
			integrationId: '@'
			onRunClick: '&'
		templateUrl: '@directive/integration-failed-transfer/integration-failed-transfer.view.html'
		controller: 'IntegrationFailedTransfersController'
		controllerAs: 'vm'
		bindToController: true

class IntegrationFailedTransfersController extends BaseController
	@register angular.module 'App.Directive'
	@inject 'IntegrationRepository'

	initialize: ->
		@isLoading = true
		@failedTransfers = []

		@IntegrationRepository
			.getFailedTransfers(@integrationId)
			.then (response) =>
				@failedTransfers = response.data
			.finally =>
				@isLoading = false
